import { AppAction } from "../../../models/action";

export const actionTypes = {
  UPDATE_NETWORKCONNECTION: `UPDATE_NETWORKCONNECTION`,
};

export const updateNetworkConnection = (isConnected: boolean): AppAction => ({
  type: actionTypes.UPDATE_NETWORKCONNECTION,
  payload: isConnected
});